import {
  RugbyLeagueConversionGoalAttribute,
  RugbyLeagueDropGoalAttribute,
  RugbyLeagueFoulAttribute,
  RugbyLeagueIncidentId,
  RugbyLeagueKickAttribute,
  RugbyLeaguePenaltyKickGoalAttribute,
  RugbyLeaguePenaltyTryAttribute,
  RugbyLeagueTackleMadeAttribute,
  RugbyLeagueTryAttribute,
  RugbyLeagueTurnoverAttribute,
} from '@collector/sportsapi-client-legacy'

import { HistoryIncidentsConfig } from '../../../configuration'

export const historyIncidentsConfig: HistoryIncidentsConfig<RugbyLeagueIncidentId> =
  {
    [RugbyLeagueIncidentId.Try]: {
      participant: { name: 'Player' },
      attributeIds: [RugbyLeagueTryAttribute.Golden],
    },
    [RugbyLeagueIncidentId.PenaltyTry]: {
      participant: { name: 'Player' },
      attributeIds: [RugbyLeaguePenaltyTryAttribute.Golden],
    },
    [RugbyLeagueIncidentId.ConversionGoal]: {
      participant: { name: 'Player' },
      attributeIds: [RugbyLeagueConversionGoalAttribute.Golden],
    },
    [RugbyLeagueIncidentId.ConversionMissed]: {
      participant: { name: 'Player' },
    },
    [RugbyLeagueIncidentId.ConversionAttempt]: {
      participant: { name: 'Player' },
    },
    [RugbyLeagueIncidentId.PenaltyKickGoal]: {
      participant: { name: 'Player' },
      attributeIds: [RugbyLeaguePenaltyKickGoalAttribute.Golden],
    },
    [RugbyLeagueIncidentId.PenaltyKickMissed]: {
      participant: { name: 'Player' },
    },
    [RugbyLeagueIncidentId.PenaltyAwarded]: { participant: { name: 'Player' } },
    [RugbyLeagueIncidentId.TackleBreak]: {
      participant: { name: 'Player' },
    },
    [RugbyLeagueIncidentId.DropGoal]: {
      participant: { name: 'Player' },
      attributeIds: [
        RugbyLeagueDropGoalAttribute.Golden,
        RugbyLeagueDropGoalAttribute.One,
        RugbyLeagueDropGoalAttribute.Two,
      ],
      attributesSelectionConstraint: (newSelection, previousSelection) => {
        const hasGolden = newSelection.includes(
          RugbyLeagueDropGoalAttribute.Golden,
        )
        const nonGolden = newSelection.filter(
          (id) => id !== RugbyLeagueDropGoalAttribute.Golden,
        )

        if (nonGolden.length > 1) {
          const added = nonGolden.find((id) => !previousSelection.includes(id))
          const kept = added ?? nonGolden.at(-1)!
          return hasGolden
            ? [RugbyLeagueDropGoalAttribute.Golden, kept]
            : [kept]
        }

        return newSelection
      },
    },
    [RugbyLeagueIncidentId.DropGoalMissed]: { participant: { name: 'Player' } },
    [RugbyLeagueIncidentId.YellowCard]: { participant: { name: 'Player' } },
    [RugbyLeagueIncidentId.RedCard]: { participant: { name: 'Player' } },
    [RugbyLeagueIncidentId.GreenCard]: { participant: { name: 'Player' } },
    [RugbyLeagueIncidentId.Injury]: { participant: { name: 'Player' } },
    [RugbyLeagueIncidentId.SubstitutionIn]: {
      participant: { name: 'Player', required: true },
    },
    [RugbyLeagueIncidentId.SubstitutionOut]: {
      participant: { name: 'Player', required: true },
    },
    [RugbyLeagueIncidentId.FreeKick]: {},
    [RugbyLeagueIncidentId.InPossession]: {},
    [RugbyLeagueIncidentId.EntryInto20]: {},
    [RugbyLeagueIncidentId.Kick]: {
      attributeIds: [
        RugbyLeagueKickAttribute.Pass,
        RugbyLeagueKickAttribute.KickForTouch,
        RugbyLeagueKickAttribute.Clearance,
        RugbyLeagueKickAttribute.RestartKick,
        RugbyLeagueKickAttribute.UpAndUnder,
        RugbyLeagueKickAttribute.TapKick,
        RugbyLeagueKickAttribute.CollectedByOffense,
        RugbyLeagueKickAttribute.FortyTwentyKick,
      ],
    },
    [RugbyLeagueIncidentId.GoallineDropout]: {},
    [RugbyLeagueIncidentId.Offload]: {},
    [RugbyLeagueIncidentId.Turnover]: {
      attributeIds: [
        RugbyLeagueTurnoverAttribute.Handover,
        RugbyLeagueTurnoverAttribute.KnockOn,
        RugbyLeagueTurnoverAttribute.ForwardPass,
        RugbyLeagueTurnoverAttribute.Intercepted,
        RugbyLeagueTurnoverAttribute.ForcedIntoTouch,
        RugbyLeagueTurnoverAttribute.LostInScrum,
      ],
    },
    [RugbyLeagueIncidentId.Foul]: {
      attributeIds: [RugbyLeagueFoulAttribute.DangerousPlay],
    },
    [RugbyLeagueIncidentId.Scrum]: {},
    [RugbyLeagueIncidentId.Lineout]: {},
    [RugbyLeagueIncidentId.TackleMade]: {
      singleAttributes: true,
      attributeIds: [
        RugbyLeagueTackleMadeAttribute.One,
        RugbyLeagueTackleMadeAttribute.Two,
        RugbyLeagueTackleMadeAttribute.Three,
        RugbyLeagueTackleMadeAttribute.Four,
        RugbyLeagueTackleMadeAttribute.Five,
        RugbyLeagueTackleMadeAttribute.Six,
      ],
    },
  }
